<template>
  <div class="addVirtualWallet">
    <div class="settingwarp">
      <header>
        <div class="g-header" style="background: linear-gradient(180deg, #161936 0%, #0e1530 100%)">
          <div class="left" @click="changego">
            <van-icon name="arrow-left" color="#fff" size="20px" />
          </div>
          <div class="middle fs-18">修改交易密码</div>
          <div class="right">
            <div class="bg-icon bg-icon-setting"></div>
          </div>
        </div>
        <div class="blockHeight"></div>
      </header>
      <div class="g-content">
        <!-- 第一次设置安全码显示这个 -->
        <template v-if="setCode == 'false'">
          <div class="security-form">
            <div class="input-group">
              <input 
                :type="showPassword1 ? 'text' : 'password'" 
                v-model="new_code"
                maxlength="6"
                placeholder="请输入六位交易密码"
                class="security-input"
                @input="validateNumberInput($event, 'new_code')"
                pattern="[0-9]*"
                inputmode="numeric"
              />
              <img 
                :src="showPassword1 ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABQ9JREFUWEftmGtoXEUUx/9nbtdNgglaSfCJWJFgFcQGxHWT3Lm7iFSkaiXVtlak9oN+qOCzilCsolYpBekHBa2I2odtsVSpLcjund10XZXG+sWg+AKtDzalVLeYrOu9R6bMhu1m793No4Ri5kvIznn85szMOWcu4SwZdJZwYg50pndqLqJzEZ1OBJLJ5ALf96/3fb8LQKexNSKEKJTL5SOHDh36cTr2te6Uz2gikej3fX81gCSASxuAHAWQYuatmUxmcCrQkwWlRCJxr+/76wBcE+Bw1PzeGjD/NYCNSqltALhZ6KZBHcfpYeYtAGIV48z8lxBiHzNnAOQAHFVKndTzUspzTaTjRGT7vn87EXVU6X5qWdbadDr9ZTOwTYHatv0IEb0MIGKMfkdEm5h5ewWskTMDvhLAYwCuMvJlAE8opV5tpB8Kunjx4ujo6OjbAO4xhnS0XigUCpuHh4f/aWS83vzChQvP6erqehTAMwB01KEX3NbWtvrAgQOlIJuBoD09PZH29vYPANxmjA0LIZa6rvvtVABrdRzH6WbmvQCuNnMfFYvFu4aGhnSUJ4y6oAMDA9axY8d2MfNSo7FfR7WJbRbxePxCrZPL5f4A4IctKh6Pt8+bN28nEd1q5PYope6tp1cX1LbtDUS03igfbG1tvSNsW/r6+i6yLGs9My8jovlmB44T0S7P854bHBz8PQjYHK99AG4xMs8qpTbUyk8AtW3bIaJPAFhE9MXY2JjM5/OVlDPBn5TyRgAfViX6WpkRAEuUUp8FwcZisdaWlhbFzDcA8Igo6bquziTj4zRQrRCNRvUZvAzACd/3F2Wz2Z+CHMTj8YsjkcjXGpKZfR1BZv5Yy+vtNBEWAEY8z7suLLL9/f1XCCF0qjqPmX8mom6l1FjF92mgUsqnALykJ33fX5nNZreHnTEp5WsAHtSQQojlruvuqpZ3HGeZ7/s7iEjDvq6UeijMnuM4K5hZFwK90HWu674yATSZTF7ged73ekUA8kqpmxrcbmHb9og5kzuVUsvryUspd+iLyMzHM5mM7gNCL5iUMg9AH6cTpVLpynw+f/wUeMW4lHINgDfManpd19WVJnCYbf/VXJz7MpnMu/WEbdteRUTv6LlyuXxJLpf7Lcyubdt9RJQ1MmuUUltrQR8A8KZx3N+oeZg10FgsNj8ajeqtPx/A50opHf6wMTtbr4kcx3mSmXVN12OVUuq92bpMAJ5WSm2ccJn0D1LKFgDfALgcwJ9CiJ50Ov1DEOyZSk8AfimVSt3V+XtCwjcNcVonfACHi8WiPTQ09HcQ7JlI+JZl3ZxKpdxqn3VLqOM4uhxWypiuUrqyjCffWuiZLKHM/Hwmk6mU73FXQd2TcBxnJzMPGMmD5XJ5WS6XKza6YNNsSvZ2dnYO7N6926v1E9rmdXR07GHmJUZJn907lVL677RHnTZvf6FQWBrU5zbTOOuEqztzPU4y84ttbW2bw7qpsFXUa5wBvA/g/rDj1dRTxHGch5l5U9VTROdb/f+2JnrUU9z6KUJEupY/XvUU+dfU9M2NtqgpUG0kkUgs8jxvCxGN9wDTedwB0G3fWqXU4UaQer5pUGOMpJQrAOgu69oAB6HPZWYetixrYzqd1sVk5p/LtVCmedD9QdMfIIQQb6XT6UrD0UwgG6anSRnp7e1dEIlE6n7SEUIcSaVSs/dJZ1IrmQHhyZ7RGXA5NRNzoFOLW7DWXET/txH9D6XYlUnokLUqAAAAAElFTkSuQmCC' : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAYAAAAqAaJlAAAAAXNSR0IArs4c6QAAA9xJREFUWEftl1uIHEUUhv9Ts+PIwCAGslHyoA8ixAejDC7sbbq6NwgDYrwiIQYvoAGzeVARBRNFI8qKoERR8SUQ0ReV4AXXBd06vdsDUVnIg6IgiiaQeMN4Gdd17a6jFXplXOeSYTKBQNfTUFPnnI+//3O6mnAGLTqDWJHB9utpZcpmygJZg/XLBZmymbJOgf/N2fHx8bW5XG47gHeY+VDfZOqQOAiCLSJyvjHmGQC2Kazv+3tFZKeI/ApgUxiGH59uYK31DgDPpXWrzPxeU9ggCLZZa/enB48TUdUY8+HpAg6C4I4kSV4kIgWgHsfxxiiKvmoK6za11k8AeCAFrBPRTcaYd/sN7HnefQCmiMjZ8w8AVzPz+yt1W94NtNZ7AOxKDyYAHmTmqX4AV6vVwtLS0gsicpvL7yyYy+WunZ2dnW2s1/Yio7WeBPA0gIE06ECSJNvn5+d/OFXQY2NjF+dyuZeJaCjN+SURbTbGfLq6Rsdbl+/7u0Xk0ZVAEfmeiHYw8+s9AiuttWvkx4momOYSIhpu1SNtYYMgGLLWOs+UmoBFRLTLGBN2CU1a6+tF5BEiumR1rIgcjuN4vFarHT5pZScmJi6N49gQ0RoRsUR0FxFdYK29l4jOakjEIvISEb3NzPVW4G5+K6VuJKI7AWxsOPeZUmrSWns7gK3p/hcAKsz8bUfPOh8NDAzMAVjn/E5Ek8aY511gpVLZoJR6FsDEKrA/ReQjpdQhETmadrN7IheKyOUALkvH0UrYLyIyVa/Xn1pYWPhLa+364jUA16QHPonjuBJF0fG208DzvJCIKidmG9H9xpgnVyvmed4VSqm7ReQGAPkurOAaaO/y8vK+Wq32W2OcmwqLi4tvEdGV6f5uZn6sLazWeh+AW0RkTxiGD7cD8TzPee+h9Mw3ANY3TA+3/TsAB3VeemYDM3/eKme5XC6WSqU3AYwqpa5qHF9NG6xcLudLpdJ6Zv66k2Ja68glBvAjM6/TWqskSc4lorOttfUoin72fX9IRA66XCJyTxiGbhy2XY7B2aOjZzslWvl/eHh4TaFQ+C5V8hVmvrlFrPI87xgRDQL4gJk3nWyNUwbred4WInrVJbTWbp2bmzvxu9lKrXWriCwXi8W109PT7qLU1er4UmiXzff9/SKyDUBSKBQGZ2ZmfmoD6xrRdbuzwnVhGB7oirTXD0bf999whUXEhGEYtCs+OjpayufzRwCcA+Dfa183wD0pOzIyMpjP5zenL4T/DPAWVrjITQVmdk3Z9eoJtutqPQZksD0K2DI8UzZTttc52y8FW+XNPNsvxTNlM2X/UeBvCp5xOk5aa8wAAAAASUVORK5CYII='"
                @click="togglePassword1"
                class="password-toggle-icon"
                alt="toggle password"
              />
            </div>
            <div class="input-group">
              <input 
                :type="showPassword2 ? 'text' : 'password'" 
                v-model="confirm_code"
                maxlength="6"
                placeholder="请再次输入密码"
                class="security-input"
                @input="validateNumberInput($event, 'confirm_code')"
                pattern="[0-9]*"
                inputmode="numeric"
              />
              <img 
                :src="showPassword2 ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABQ9JREFUWEftmGtoXEUUx/9nbtdNgglaSfCJWJFgFcQGxHWT3Lm7iFSkaiXVtlak9oN+qOCzilCsolYpBekHBa2I2odtsVSpLcjund10XZXG+sWg+AKtDzalVLeYrOu9R6bMhu1m793No4Ri5kvIznn85szMOWcu4SwZdJZwYg50pndqLqJzEZ1OBJLJ5ALf96/3fb8LQKexNSKEKJTL5SOHDh36cTr2te6Uz2gikej3fX81gCSASxuAHAWQYuatmUxmcCrQkwWlRCJxr+/76wBcE+Bw1PzeGjD/NYCNSqltALhZ6KZBHcfpYeYtAGIV48z8lxBiHzNnAOQAHFVKndTzUspzTaTjRGT7vn87EXVU6X5qWdbadDr9ZTOwTYHatv0IEb0MIGKMfkdEm5h5ewWskTMDvhLAYwCuMvJlAE8opV5tpB8Kunjx4ujo6OjbAO4xhnS0XigUCpuHh4f/aWS83vzChQvP6erqehTAMwB01KEX3NbWtvrAgQOlIJuBoD09PZH29vYPANxmjA0LIZa6rvvtVABrdRzH6WbmvQCuNnMfFYvFu4aGhnSUJ4y6oAMDA9axY8d2MfNSo7FfR7WJbRbxePxCrZPL5f4A4IctKh6Pt8+bN28nEd1q5PYope6tp1cX1LbtDUS03igfbG1tvSNsW/r6+i6yLGs9My8jovlmB44T0S7P854bHBz8PQjYHK99AG4xMs8qpTbUyk8AtW3bIaJPAFhE9MXY2JjM5/OVlDPBn5TyRgAfViX6WpkRAEuUUp8FwcZisdaWlhbFzDcA8Igo6bquziTj4zRQrRCNRvUZvAzACd/3F2Wz2Z+CHMTj8YsjkcjXGpKZfR1BZv5Yy+vtNBEWAEY8z7suLLL9/f1XCCF0qjqPmX8mom6l1FjF92mgUsqnALykJ33fX5nNZreHnTEp5WsAHtSQQojlruvuqpZ3HGeZ7/s7iEjDvq6UeijMnuM4K5hZFwK90HWu674yATSZTF7ged73ekUA8kqpmxrcbmHb9og5kzuVUsvryUspd+iLyMzHM5mM7gNCL5iUMg9AH6cTpVLpynw+f/wUeMW4lHINgDfManpd19WVJnCYbf/VXJz7MpnMu/WEbdteRUTv6LlyuXxJLpf7Lcyubdt9RJQ1MmuUUltrQR8A8KZx3N+oeZg10FgsNj8ajeqtPx/A50opHf6wMTtbr4kcx3mSmXVN12OVUuq92bpMAJ5WSm2ccJn0D1LKFgDfALgcwJ9CiJ50Ov1DEOyZSk8AfimVSt3V+XtCwjcNcVonfACHi8WiPTQ09HcQ7JlI+JZl3ZxKpdxqn3VLqOM4uhxWypiuUrqyjCffWuiZLKHM/Hwmk6mU73FXQd2TcBxnJzMPGMmD5XJ5WS6XKza6YNNsSvZ2dnYO7N6926v1E9rmdXR07GHmJUZJn907lVL677RHnTZvf6FQWBrU5zbTOOuEqztzPU4y84ttbW2bw7qpsFXUa5wBvA/g/rDj1dRTxHGch5l5U9VTROdb/f+2JnrUU9z6KUJEupY/XvUU+dfU9M2NtqgpUG0kkUgs8jxvCxGN9wDTedwB0G3fWqXU4UaQer5pUGOMpJQrAOgu69oAB6HPZWYetixrYzqd1sVk5p/LtVCmedD9QdMfIIQQb6XT6UrD0UwgG6anSRnp7e1dEIlE6n7SEUIcSaVSs/dJZ1IrmQHhyZ7RGXA5NRNzoFOLW7DWXET/txH9D6XYlUnokLUqAAAAAElFTkSuQmCC' : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAYAAAAqAaJlAAAAAXNSR0IArs4c6QAAA9xJREFUWEftl1uIHEUUhv9Ts+PIwCAGslHyoA8ixAejDC7sbbq6NwgDYrwiIQYvoAGzeVARBRNFI8qKoERR8SUQ0ReV4AXXBd06vdsDUVnIg6IgiiaQeMN4Gdd17a6jFXplXOeSYTKBQNfTUFPnnI+//3O6mnAGLTqDWJHB9utpZcpmygJZg/XLBZmymbJOgf/N2fHx8bW5XG47gHeY+VDfZOqQOAiCLSJyvjHmGQC2Kazv+3tFZKeI/ApgUxiGH59uYK31DgDPpXWrzPxeU9ggCLZZa/enB48TUdUY8+HpAg6C4I4kSV4kIgWgHsfxxiiKvmoK6za11k8AeCAFrBPRTcaYd/sN7HnefQCmiMjZ8w8AVzPz+yt1W94NtNZ7AOxKDyYAHmTmqX4AV6vVwtLS0gsicpvL7yyYy+WunZ2dnW2s1/Yio7WeBPA0gIE06ECSJNvn5+d/OFXQY2NjF+dyuZeJaCjN+SURbTbGfLq6Rsdbl+/7u0Xk0ZVAEfmeiHYw8+s9AiuttWvkx4momOYSIhpu1SNtYYMgGLLWOs+UmoBFRLTLGBN2CU1a6+tF5BEiumR1rIgcjuN4vFarHT5pZScmJi6N49gQ0RoRsUR0FxFdYK29l4jOakjEIvISEb3NzPVW4G5+K6VuJKI7AWxsOPeZUmrSWns7gK3p/hcAKsz8bUfPOh8NDAzMAVjn/E5Ek8aY511gpVLZoJR6FsDEKrA/ReQjpdQhETmadrN7IheKyOUALkvH0UrYLyIyVa/Xn1pYWPhLa+364jUA16QHPonjuBJF0fG208DzvJCIKidmG9H9xpgnVyvmed4VSqm7ReQGAPkurOAaaO/y8vK+Wq32W2OcmwqLi4tvEdGV6f5uZn6sLazWeh+AW0RkTxiGD7cD8TzPee+h9Mw3ANY3TA+3/TsAB3VeemYDM3/eKme5XC6WSqU3AYwqpa5qHF9NG6xcLudLpdJ6Zv66k2Ja68glBvAjM6/TWqskSc4lorOttfUoin72fX9IRA66XCJyTxiGbhy2XY7B2aOjZzslWvl/eHh4TaFQ+C5V8hVmvrlFrPI87xgRDQL4gJk3nWyNUwbred4WInrVJbTWbp2bmzvxu9lKrXWriCwXi8W109PT7qLU1er4UmiXzff9/SKyDUBSKBQGZ2ZmfmoD6xrRdbuzwnVhGB7oirTXD0bf999whUXEhGEYtCs+OjpayufzRwCcA+Dfa183wD0pOzIyMpjP5zenL4T/DPAWVrjITQVmdk3Z9eoJtutqPQZksD0K2DI8UzZTttc52y8FW+XNPNsvxTNlM2X/UeBvCp5xOk5aa8wAAAAASUVORK5CYII='"
                @click="togglePassword2"
                class="password-toggle-icon"
                alt="toggle password"
              />
            </div>
          </div>
          <div class="submit-container">
            <button class="submit-button" @click="setSafetyFirst">提交</button>
          </div>
        </template>
        <!-- 后续修改安全码显示这个 -->
        <template v-if="setCode == 'true'">
          <div class="security-form">
            <div class="input-group">
              <input 
                :type="showPassword3 ? 'text' : 'password'" 
                v-model="after_code"
                maxlength="6"
                placeholder="请输入旧密码"
                class="security-input"
                @input="validateNumberInput($event, 'after_code')"
                pattern="[0-9]*"
                inputmode="numeric"
              />
              <img 
                :src="showPassword3 ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABQ9JREFUWEftmGtoXEUUx/9nbtdNgglaSfCJWJFgFcQGxHWT3Lm7iFSkaiXVtlak9oN+qOCzilCsolYpBekHBa2I2odtsVSpLcjund10XZXG+sWg+AKtDzalVLeYrOu9R6bMhu1m793No4Ri5kvIznn85szMOWcu4SwZdJZwYg50pndqLqJzEZ1OBJLJ5ALf96/3fb8LQKexNSKEKJTL5SOHDh36cTr2te6Uz2gikej3fX81gCSASxuAHAWQYuatmUxmcCrQkwWlRCJxr+/76wBcE+Bw1PzeGjD/NYCNSqltALhZ6KZBHcfpYeYtAGIV48z8lxBiHzNnAOQAHFVKndTzUspzTaTjRGT7vn87EXVU6X5qWdbadDr9ZTOwTYHatv0IEb0MIGKMfkdEm5h5ewWskTMDvhLAYwCuMvJlAE8opV5tpB8Kunjx4ujo6OjbAO4xhnS0XigUCpuHh4f/aWS83vzChQvP6erqehTAMwB01KEX3NbWtvrAgQOlIJuBoD09PZH29vYPANxmjA0LIZa6rvvtVABrdRzH6WbmvQCuNnMfFYvFu4aGhnSUJ4y6oAMDA9axY8d2MfNSo7FfR7WJbRbxePxCrZPL5f4A4IctKh6Pt8+bN28nEd1q5PYope6tp1cX1LbtDUS03igfbG1tvSNsW/r6+i6yLGs9My8jovlmB44T0S7P854bHBz8PQjYHK99AG4xMs8qpTbUyk8AtW3bIaJPAFhE9MXY2JjM5/OVlDPBn5TyRgAfViX6WpkRAEuUUp8FwcZisdaWlhbFzDcA8Igo6bquziTj4zRQrRCNRvUZvAzACd/3F2Wz2Z+CHMTj8YsjkcjXGpKZfR1BZv5Yy+vtNBEWAEY8z7suLLL9/f1XCCF0qjqPmX8mom6l1FjF92mgUsqnALykJ33fX5nNZreHnTEp5WsAHtSQQojlruvuqpZ3HGeZ7/s7iEjDvq6UeijMnuM4K5hZFwK90HWu674yATSZTF7ged73ekUA8kqpmxrcbmHb9og5kzuVUsvryUspd+iLyMzHM5mM7gNCL5iUMg9AH6cTpVLpynw+f/wUeMW4lHINgDfManpd19WVJnCYbf/VXJz7MpnMu/WEbdteRUTv6LlyuXxJLpf7Lcyubdt9RJQ1MmuUUltrQR8A8KZx3N+oeZg10FgsNj8ajeqtPx/A50opHf6wMTtbr4kcx3mSmXVN12OVUuq92bpMAJ5WSm2ccJn0D1LKFgDfALgcwJ9CiJ50Ov1DEOyZSk8AfimVSt3V+XtCwjcNcVonfACHi8WiPTQ09HcQ7JlI+JZl3ZxKpdxqn3VLqOM4uhxWypiuUrqyjCffWuiZLKHM/Hwmk6mU73FXQd2TcBxnJzMPGMmD5XJ5WS6XKza6YNNsSvZ2dnYO7N6926v1E9rmdXR07GHmJUZJn907lVL677RHnTZvf6FQWBrU5zbTOOuEqztzPU4y84ttbW2bw7qpsFXUa5wBvA/g/rDj1dRTxHGch5l5U9VTROdb/f+2JnrUU9z6KUJEupY/XvUU+dfU9M2NtqgpUG0kkUgs8jxvCxGN9wDTedwB0G3fWqXU4UaQer5pUGOMpJQrAOgu69oAB6HPZWYetixrYzqd1sVk5p/LtVCmedD9QdMfIIQQb6XT6UrD0UwgG6anSRnp7e1dEIlE6n7SEUIcSaVSs/dJZ1IrmQHhyZ7RGXA5NRNzoFOLW7DWXET/txH9D6XYlUnokLUqAAAAAElFTkSuQmCC' : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAYAAAAqAaJlAAAAAXNSR0IArs4c6QAAA9xJREFUWEftl1uIHEUUhv9Ts+PIwCAGslHyoA8ixAejDC7sbbq6NwgDYrwiIQYvoAGzeVARBRNFI8qKoERR8SUQ0ReV4AXXBd06vdsDUVnIg6IgiiaQeMN4Gdd17a6jFXplXOeSYTKBQNfTUFPnnI+//3O6mnAGLTqDWJHB9utpZcpmygJZg/XLBZmymbJOgf/N2fHx8bW5XG47gHeY+VDfZOqQOAiCLSJyvjHmGQC2Kazv+3tFZKeI/ApgUxiGH59uYK31DgDPpXWrzPxeU9ggCLZZa/enB48TUdUY8+HpAg6C4I4kSV4kIgWgHsfxxiiKvmoK6za11k8AeCAFrBPRTcaYd/sN7HnefQCmiMjZ8w8AVzPz+yt1W94NtNZ7AOxKDyYAHmTmqX4AV6vVwtLS0gsicpvL7yyYy+WunZ2dnW2s1/Yio7WeBPA0gIE06ECSJNvn5+d/OFXQY2NjF+dyuZeJaCjN+SURbTbGfLq6Rsdbl+/7u0Xk0ZVAEfmeiHYw8+s9AiuttWvkx4momOYSIhpu1SNtYYMgGLLWOs+UmoBFRLTLGBN2CU1a6+tF5BEiumR1rIgcjuN4vFarHT5pZScmJi6N49gQ0RoRsUR0FxFdYK29l4jOakjEIvISEb3NzPVW4G5+K6VuJKI7AWxsOPeZUmrSWns7gK3p/hcAKsz8bUfPOh8NDAzMAVjn/E5Ek8aY511gpVLZoJR6FsDEKrA/ReQjpdQhETmadrN7IheKyOUALkvH0UrYLyIyVa/Xn1pYWPhLa+364jUA16QHPonjuBJF0fG208DzvJCIKidmG9H9xpgnVyvmed4VSqm7ReQGAPkurOAaaO/y8vK+Wq32W2OcmwqLi4tvEdGV6f5uZn6sLazWeh+AW0RkTxiGD7cD8TzPee+h9Mw3ANY3TA+3/TsAB3VeemYDM3/eKme5XC6WSqU3AYwqpa5qHF9NG6xcLudLpdJ6Zv66k2Ja68glBvAjM6/TWqskSc4lorOttfUoin72fX9IRA66XCJyTxiGbhy2XY7B2aOjZzslWvl/eHh4TaFQ+C5V8hVmvrlFrPI87xgRDQL4gJk3nWyNUwbred4WInrVJbTWbp2bmzvxu9lKrXWriCwXi8W109PT7qLU1er4UmiXzff9/SKyDUBSKBQGZ2ZmfmoD6xrRdbuzwnVhGB7oirTXD0bf999whUXEhGEYtCs+OjpayufzRwCcA+Dfa183wD0pOzIyMpjP5zenL4T/DPAWVrjITQVmdk3Z9eoJtutqPQZksD0K2DI8UzZTttc52y8FW+XNPNsvxTNlM2X/UeBvCp5xOk5aa8wAAAAASUVORK5CYII='"
                @click="togglePassword3"
                class="password-toggle-icon"
                alt="toggle password"
              />
            </div>
            <div class="input-group">
              <input 
                :type="showPassword4 ? 'text' : 'password'" 
                v-model="new_code"
                maxlength="6"
                placeholder="交易密码只能是六位数字"
                class="security-input"
                @input="validateNumberInput($event, 'new_code')"
                pattern="[0-9]*"
                inputmode="numeric"
              />
              <img 
                :src="showPassword4 ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABQ9JREFUWEftmGtoXEUUx/9nbtdNgglaSfCJWJFgFcQGxHWT3Lm7iFSkaiXVtlak9oN+qOCzilCsolYpBekHBa2I2odtsVSpLcjund10XZXG+sWg+AKtDzalVLeYrOu9R6bMhu1m793No4Ri5kvIznn85szMOWcu4SwZdJZwYg50pndqLqJzEZ1OBJLJ5ALf96/3fb8LQKexNSKEKJTL5SOHDh36cTr2te6Uz2gikej3fX81gCSASxuAHAWQYuatmUxmcCrQkwWlRCJxr+/76wBcE+Bw1PzeGjD/NYCNSqltALhZ6KZBHcfpYeYtAGIV48z8lxBiHzNnAOQAHFVKndTzUspzTaTjRGT7vn87EXVU6X5qWdbadDr9ZTOwTYHatv0IEb0MIGKMfkdEm5h5ewWskTMDvhLAYwCuMvJlAE8opV5tpB8Kunjx4ujo6OjbAO4xhnS0XigUCpuHh4f/aWS83vzChQvP6erqehTAMwB01KEX3NbWtvrAgQOlIJuBoD09PZH29vYPANxmjA0LIZa6rvvtVABrdRzH6WbmvQCuNnMfFYvFu4aGhnSUJ4y6oAMDA9axY8d2MfNSo7FfR7WJbRbxePxCrZPL5f4A4IctKh6Pt8+bN28nEd1q5PYope6tp1cX1LbtDUS03igfbG1tvSNsW/r6+i6yLGs9My8jovlmB44T0S7P854bHBz8PQjYHK99AG4xMs8qpTbUyk8AtW3bIaJPAFhE9MXY2JjM5/OVlDPBn5TyRgAfViX6WpkRAEuUUp8FwcZisdaWlhbFzDcA8Igo6bquziTj4zRQrRCNRvUZvAzACd/3F2Wz2Z+CHMTj8YsjkcjXGpKZfR1BZv5Yy+vtNBEWAEY8z7suLLL9/f1XCCF0qjqPmX8mom6l1FjF92mgUsqnALykJ33fX5nNZreHnTEp5WsAHtSQQojlruvuqpZ3HGeZ7/s7iEjDvq6UeijMnuM4K5hZFwK90HWu674yATSZTF7ged73ekUA8kqpmxrcbmHb9og5kzuVUsvryUspd+iLyMzHM5mM7gNCL5iUMg9AH6cTpVLpynw+f/wUeMW4lHINgDfManpd19WVJnCYbf/VXJz7MpnMu/WEbdteRUTv6LlyuXxJLpf7Lcyubdt9RJQ1MmuUUltrQR8A8KZx3N+oeZg10FgsNj8ajeqtPx/A50opHf6wMTtbr4kcx3mSmXVN12OVUuq92bpMAJ5WSm2ccJn0D1LKFgDfALgcwJ9CiJ50Ov1DEOyZSk8AfimVSt3V+XtCwjcNcVonfACHi8WiPTQ09HcQ7JlI+JZl3ZxKpdxqn3VLqOM4uhxWypiuUrqyjCffWuiZLKHM/Hwmk6mU73FXQd2TcBxnJzMPGMmD5XJ5WS6XKza6YNNsSvZ2dnYO7N6926v1E9rmdXR07GHmJUZJn907lVL677RHnTZvf6FQWBrU5zbTOOuEqztzPU4y84ttbW2bw7qpsFXUa5wBvA/g/rDj1dRTxHGch5l5U9VTROdb/f+2JnrUU9z6KUJEupY/XvUU+dfU9M2NtqgpUG0kkUgs8jxvCxGN9wDTedwB0G3fWqXU4UaQer5pUGOMpJQrAOgu69oAB6HPZWYetixrYzqd1sVk5p/LtVCmedD9QdMfIIQQb6XT6UrD0UwgG6anSRnp7e1dEIlE6n7SEUIcSaVSs/dJZ1IrmQHhyZ7RGXA5NRNzoFOLW7DWXET/txH9D6XYlUnokLUqAAAAAElFTkSuQmCC' : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAYAAAAqAaJlAAAAAXNSR0IArs4c6QAAA9xJREFUWEftl1uIHEUUhv9Ts+PIwCAGslHyoA8ixAejDC7sbbq6NwgDYrwiIQYvoAGzeVARBRNFI8qKoERR8SUQ0ReV4AXXBd06vdsDUVnIg6IgiiaQeMN4Gdd17a6jFXplXOeSYTKBQNfTUFPnnI+//3O6mnAGLTqDWJHB9utpZcpmygJZg/XLBZmymbJOgf/N2fHx8bW5XG47gHeY+VDfZOqQOAiCLSJyvjHmGQC2Kazv+3tFZKeI/ApgUxiGH59uYK31DgDPpXWrzPxeU9ggCLZZa/enB48TUdUY8+HpAg6C4I4kSV4kIgWgHsfxxiiKvmoK6za11k8AeCAFrBPRTcaYd/sN7HnefQCmiMjZ8w8AVzPz+yt1W94NtNZ7AOxKDyYAHmTmqX4AV6vVwtLS0gsicpvL7yyYy+WunZ2dnW2s1/Yio7WeBPA0gIE06ECSJNvn5+d/OFXQY2NjF+dyuZeJaCjN+SURbTbGfLq6Rsdbl+/7u0Xk0ZVAEfmeiHYw8+s9AiuttWvkx4momOYSIhpu1SNtYYMgGLLWOs+UmoBFRLTLGBN2CU1a6+tF5BEiumR1rIgcjuN4vFarHT5pZScmJi6N49gQ0RoRsUR0FxFdYK29l4jOakjEIvISEb3NzPVW4G5+K6VuJKI7AWxsOPeZUmrSWns7gK3p/hcAKsz8bUfPOh8NDAzMAVjn/E5Ek8aY511gpVLZoJR6FsDEKrA/ReQjpdQhETmadrN7IheKyOUALkvH0UrYLyIyVa/Xn1pYWPhLa+364jUA16QHPonjuBJF0fG208DzvJCIKidmG9H9xpgnVyvmed4VSqm7ReQGAPkurOAaaO/y8vK+Wq32W2OcmwqLi4tvEdGV6f5uZn6sLazWeh+AW0RkTxiGD7cD8TzPee+h9Mw3ANY3TA+3/TsAB3VeemYDM3/eKme5XC6WSqU3AYwqpa5qHF9NG6xcLudLpdJ6Zv66k2Ja68glBvAjM6/TWqskSc4lorOttfUoin72fX9IRA66XCJyTxiGbhy2XY7B2aOjZzslWvl/eHh4TaFQ+C5V8hVmvrlFrPI87xgRDQL4gJk3nWyNUwbred4WInrVJbTWbp2bmzvxu9lKrXWriCwXi8W109PT7qLU1er4UmiXzff9/SKyDUBSKBQGZ2ZmfmoD6xrRdbuzwnVhGB7oirTXD0bf999whUXEhGEYtCs+OjpayufzRwCcA+Dfa183wD0pOzIyMpjP5zenL4T/DPAWVrjITQVmdk3Z9eoJtutqPQZksD0K2DI8UzZTttc52y8FW+XNPNsvxTNlM2X/UeBvCp5xOk5aa8wAAAAASUVORK5CYII='"
                @click="togglePassword4"
                class="password-toggle-icon"
                alt="toggle password"
              />
            </div>
            <div class="input-group">
              <input 
                :type="showPassword5 ? 'text' : 'password'" 
                v-model="confirm_new_code"
                maxlength="6"
                placeholder="请输入确认交易密码"
                class="security-input"
                @input="validateNumberInput($event, 'confirm_new_code')"
                pattern="[0-9]*"
                inputmode="numeric"
              />
              <img 
                :src="showPassword5 ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABQ9JREFUWEftmGtoXEUUx/9nbtdNgglaSfCJWJFgFcQGxHWT3Lm7iFSkaiXVtlak9oN+qOCzilCsolYpBekHBa2I2odtsVSpLcjund10XZXG+sWg+AKtDzalVLeYrOu9R6bMhu1m793No4Ri5kvIznn85szMOWcu4SwZdJZwYg50pndqLqJzEZ1OBJLJ5ALf96/3fb8LQKexNSKEKJTL5SOHDh36cTr2te6Uz2gikej3fX81gCSASxuAHAWQYuatmUxmcCrQkwWlRCJxr+/76wBcE+Bw1PzeGjD/NYCNSqltALhZ6KZBHcfpYeYtAGIV48z8lxBiHzNnAOQAHFVKndTzUspzTaTjRGT7vn87EXVU6X5qWdbadDr9ZTOwTYHatv0IEb0MIGKMfkdEm5h5ewWskTMDvhLAYwCuMvJlAE8opV5tpB8Kunjx4ujo6OjbAO4xhnS0XigUCpuHh4f/aWS83vzChQvP6erqehTAMwB01KEX3NbWtvrAgQOlIJuBoD09PZH29vYPANxmjA0LIZa6rvvtVABrdRzH6WbmvQCuNnMfFYvFu4aGhnSUJ4y6oAMDA9axY8d2MfNSo7FfR7WJbRbxePxCrZPL5f4A4IctKh6Pt8+bN28nEd1q5PYope6tp1cX1LbtDUS03igfbG1tvSNsW/r6+i6yLGs9My8jovlmB44T0S7P854bHBz8PQjYHK99AG4xMs8qpTbUyk8AtW3bIaJPAFhE9MXY2JjM5/OVlDPBn5TyRgAfViX6WpkRAEuUUp8FwcZisdaWlhbFzDcA8Igo6bquziTj4zRQrRCNRvUZvAzACd/3F2Wz2Z+CHMTj8YsjkcjXGpKZfR1BZv5Yy+vtNBEWAEY8z7suLLL9/f1XCCF0qjqPmX8mom6l1FjF92mgUsqnALykJ33fX5nNZreHnTEp5WsAHtSQQojlruvuqpZ3HGeZ7/s7iEjDvq6UeijMnuM4K5hZFwK90HWu674yATSZTF7ged73ekUA8kqpmxrcbmHb9og5kzuVUsvryUspd+iLyMzHM5mM7gNCL5iUMg9AH6cTpVLpynw+f/wUeMW4lHINgDfManpd19WVJnCYbf/VXJz7MpnMu/WEbdteRUTv6LlyuXxJLpf7Lcyubdt9RJQ1MmuUUltrQR8A8KZx3N+oeZg10FgsNj8ajeqtPx/A50opHf6wMTtbr4kcx3mSmXVN12OVUuq92bpMAJ5WSm2ccJn0D1LKFgDfALgcwJ9CiJ50Ov1DEOyZSk8AfimVSt3V+XtCwjcNcVonfACHi8WiPTQ09HcQ7JlI+JZl3ZxKpdxqn3VLqOM4uhxWypiuUrqyjCffWuiZLKHM/Hwmk6mU73FXQd2TcBxnJzMPGMmD5XJ5WS6XKza6YNNsSvZ2dnYO7N6926v1E9rmdXR07GHmJUZJn907lVL677RHnTZvf6FQWBrU5zbTOOuEqztzPU4y84ttbW2bw7qpsFXUa5wBvA/g/rDj1dRTxHGch5l5U9VTROdb/f+2JnrUU9z6KUJEupY/XvUU+dfU9M2NtqgpUG0kkUgs8jxvCxGN9wDTedwB0G3fWqXU4UaQer5pUGOMpJQrAOgu69oAB6HPZWYetixrYzqd1sVk5p/LtVCmedD9QdMfIIQQb6XT6UrD0UwgG6anSRnp7e1dEIlE6n7SEUIcSaVSs/dJZ1IrmQHhyZ7RGXA5NRNzoFOLW7DWXET/txH9D6XYlUnokLUqAAAAAElFTkSuQmCC' : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAYAAAAqAaJlAAAAAXNSR0IArs4c6QAAA9xJREFUWEftl1uIHEUUhv9Ts+PIwCAGslHyoA8ixAejDC7sbbq6NwgDYrwiIQYvoAGzeVARBRNFI8qKoERR8SUQ0ReV4AXXBd06vdsDUVnIg6IgiiaQeMN4Gdd17a6jFXplXOeSYTKBQNfTUFPnnI+//3O6mnAGLTqDWJHB9utpZcpmygJZg/XLBZmymbJOgf/N2fHx8bW5XG47gHeY+VDfZOqQOAiCLSJyvjHmGQC2Kazv+3tFZKeI/ApgUxiGH59uYK31DgDPpXWrzPxeU9ggCLZZa/enB48TUdUY8+HpAg6C4I4kSV4kIgWgHsfxxiiKvmoK6za11k8AeCAFrBPRTcaYd/sN7HnefQCmiMjZ8w8AVzPz+yt1W94NtNZ7AOxKDyYAHmTmqX4AV6vVwtLS0gsicpvL7yyYy+WunZ2dnW2s1/Yio7WeBPA0gIE06ECSJNvn5+d/OFXQY2NjF+dyuZeJaCjN+SURbTbGfLq6Rsdbl+/7u0Xk0ZVAEfmeiHYw8+s9AiuttWvkx4momOYSIhpu1SNtYYMgGLLWOs+UmoBFRLTLGBN2CU1a6+tF5BEiumR1rIgcjuN4vFarHT5pZScmJi6N49gQ0RoRsUR0FxFdYK29l4jOakjEIvISEb3NzPVW4G5+K6VuJKI7AWxsOPeZUmrSWns7gK3p/hcAKsz8bUfPOh8NDAzMAVjn/E5Ek8aY511gpVLZoJR6FsDEKrA/ReQjpdQhETmadrN7IheKyOUALkvH0UrYLyIyVa/Xn1pYWPhLa+364jUA16QHPonjuBJF0fG208DzvJCIKidmG9H9xpgnVyvmed4VSqm7ReQGAPkurOAaaO/y8vK+Wq32W2OcmwqLi4tvEdGV6f5uZn6sLazWeh+AW0RkTxiGD7cD8TzPee+h9Mw3ANY3TA+3/TsAB3VeemYDM3/eKme5XC6WSqU3AYwqpa5qHF9NG6xcLudLpdJ6Zv66k2Ja68glBvAjM6/TWqskSc4lorOttfUoin72fX9IRA66XCJyTxiGbhy2XY7B2aOjZzslWvl/eHh4TaFQ+C5V8hVmvrlFrPI87xgRDQL4gJk3nWyNUwbred4WInrVJbTWbp2bmzvxu9lKrXWriCwXi8W109PT7qLU1er4UmiXzff9/SKyDUBSKBQGZ2ZmfmoD6xrRdbuzwnVhGB7oirTXD0bf999whUXEhGEYtCs+OjpayufzRwCcA+Dfa183wD0pOzIyMpjP5zenL4T/DPAWVrjITQVmdk3Z9eoJtutqPQZksD0K2DI8UzZTttc52y8FW+XNPNsvxTNlM2X/UeBvCp5xOk5aa8wAAAAASUVORK5CYII='"
                @click="togglePassword5"
                class="password-toggle-icon"
                alt="toggle password"
              />
            </div>
          </div>
          <div class="submit-container">
            <button class="submit-button" @click="setSafetyModify">提交</button>
          </div>
        </template>
      </div>
    </div>
    <alert-pop
      :alertType="3"
      :Tips="TipsTxt"
      v-if="PopAlert"
      @showAletfalse="showAletfalse"
    ></alert-pop>
  </div>
</template>
<script>
import AlertPop from "@/components/alert/AlertPop.vue";
import userApi from "@/api/user";
export default {
  name: "AddVirtualWallet",
  components: {
    AlertPop,
  },
  data() {
    return {
      PopAlert: false,
      setCode: null,
      showKeyboard: true,
      value: "",
      new_code: "",
      confirm_code: "", // 新增确认密码字段
      confirm_new_code: "", // 新增修改安全码时的确认密码字段
      after_code: "",
      TipsTxt: this.$t('Tips.szcg'),
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,
      showPassword4: false,
      showPassword5: false,
    };
  },
  watch: {
    // 移除原来的watcher，因为现在使用按钮点击来提交
  },
  methods: {
    showAletfalse() {
      this.PopAlert = false;
      this.$router.go(-1);
    },
    changego() {
      this.$router.go(-1);
    },
    togglePassword1() {
      this.showPassword1 = !this.showPassword1;
    },
    togglePassword2() {
      this.showPassword2 = !this.showPassword2;
    },
    togglePassword3() {
      this.showPassword3 = !this.showPassword3;
    },
    togglePassword4() {
      this.showPassword4 = !this.showPassword4;
    },
    togglePassword5() {
      this.showPassword5 = !this.showPassword5;
    },
    // 第一次设置安全码的方法
    setSafetyFirst() {
      if (!this.new_code) {
        this.$toast('请输入新安全码');
      } else if (this.new_code !== this.confirm_code) {
        this.$toast('两次输入的密码不一致');
      } else {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        });

        userApi
          .setSafety(this.new_code, this.after_code)
          .then((data) => {
            console.log(data.data);
            this.$toast.clear();
            this.PopAlert = true;
          })
          .catch((err) => {
            this.$toast.clear();
            this.$toast.fail(err.msg);
          });
      }
    },
    // 后续修改安全码的方法（新样式）
    setSafetyModify() {
      if (!this.after_code) {
        this.$toast('请输入原安全码');
      } else if (!this.new_code) {
        this.$toast('请输入新安全码');
      } else if (this.new_code !== this.confirm_new_code) {
        this.$toast('两次输入的新安全码不一致');
      } else {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        });

        userApi
          .setSafety(this.new_code, this.after_code)
          .then((data) => {
            console.log(data.data);
            this.$toast.clear();
            this.PopAlert = true;
          })
          .catch((err) => {
            this.$toast.clear();
            this.$toast.fail(err.msg);
          });
      }
    },
    // 后续修改安全码的方法（保留原有方法以防兼容性问题）
    setSafety() {
      if (!this.after_code) {
        this.$toast('请输入原安全码');
      } else if (!this.new_code && this.setCode) {
        this.$toast('请输入新安全码');
      } else {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        });

        userApi
          .setSafety(this.new_code, this.after_code)
          .then((data) => {
            console.log(data.data);
            this.$toast.clear();
            this.PopAlert = true;
          })
          .catch((err) => {
            this.$toast.clear();
            this.$toast.fail(err.msg);
          });
      }
    },
    // 验证数字输入，只允许输入0-9的数字，最多6位
    validateNumberInput(event, fieldName) {
      const value = event.target.value;
      // 只保留数字字符
      const numericValue = value.replace(/[^0-9]/g, '');
      // 限制最多6位数字
      const limitedValue = numericValue.slice(0, 6);
      
      // 更新对应的数据字段
      this[fieldName] = limitedValue;
      
      // 更新输入框的值
      event.target.value = limitedValue;
    },
  },
  mounted() {},
  created() {
    this.setCode = this.$route.query.isTrue;
  },
};
</script>
<style lang="less" scoped>
.addVirtualWallet {
  min-height: 100vh;
  background: #050925;
}

.settingwarp {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100vh;
}
.lock-bg {
  position: relative;
  text-align: center;
  width: 9rem;
  height: 6rem;
  margin: 0 auto;
  margin-top: 1.8rem;
  background: url(../assets/image/anquanma.png) no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
  padding: 0.6rem 0.2rem;
}
.paycode {
  margin-top: 0.2rem;
}
.van-number-keyboard {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #1a243f;
  -webkit-user-select: none;
  user-select: none;
}
.tips {
  width: 8.4rem;
  display: flex;
  margin: 0.4rem auto 1rem;
  align-items: flex-start;
  font-size: 0.35rem;
  img {
    width: 0.4rem;
    margin-right: 0.12rem;
  }
}
.c_a0a0a0 {
  color: #a0a0a0;
}

.addtitle {
  color: #fff;
}

.van-cell::after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 16px;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #3d5179;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.finish-btn {
  margin-top: auto;
  margin-bottom: 0.4rem;
  padding: 0.2rem;
}
.Btnlogin {
  color: #fff;
  background-color: #7d58c6;
  border: 1px solid #7d58c6;
}

/* 新增的安全码设置样式 */
.security-form {
  padding: 40px 30px 0;
}

.input-group {
  margin-bottom: 12px;
  position: relative;
  display: flex;
  align-items: center;
}

.security-input {
  flex: 1;
  background: transparent;
  border: none;
  border-bottom: .02667rem solid #ececec;
    outline: none;
    color: #fff;
    font-size: 16px;
    padding: 16px 45px 15px 26px;
    line-height: 1.5;
    border-radius: .11333rem;
}

.password-toggle-icon {
  position: absolute;
  right: 10px;
  width: 25px;
  height: 25px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.password-toggle-icon:hover {
  opacity: 1;
}

.security-input::placeholder {
  color: #999;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.security-input:focus {
  border-bottom-color: #ff8164;
}

.submit-container {
  padding: 60px 30px 40px;
}

.submit-button {
  width: 100%;
  height: 50px;
  background: linear-gradient(135deg, #00bfff 0%, #1e90ff 100%);
  border: none;
  border-radius: 25px;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
}

.submit-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(30, 144, 255, 0.3);
}

.submit-button:active {
  transform: translateY(0);
}
</style>